import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import MuiLink from '@mui/material/Link'

export default function Link (props) {
  return (
    <MuiLink { ...props } component={ RouterLink } />
  )
}
